import { render, staticRenderFns } from "./BestForKids.vue?vue&type=template&id=2ef2f53a&"
import script from "./BestForKids.vue?vue&type=script&lang=js&"
export * from "./BestForKids.vue?vue&type=script&lang=js&"
import style0 from "./BestForKids.vue?vue&type=style&index=0&id=2ef2f53a&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef2f53a')) {
      api.createRecord('2ef2f53a', component.options)
    } else {
      api.reload('2ef2f53a', component.options)
    }
    module.hot.accept("./BestForKids.vue?vue&type=template&id=2ef2f53a&", function () {
      api.rerender('2ef2f53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/BestForKids.vue"
export default component.exports